import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, CTA_LABEL, trackInitiateCheckout } from './checkout';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-ivory" data-id="element-153" data-mp="9ll6ipqopkjt">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-leather/60 via-ivory to-ivory -z-10" data-id="element-154" data-mp="4mrteyfb7vk6" />

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-155" data-mp="1274mfkm8f854">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-156" data-mp="xb5qnbykqnuo">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/60 bg-forest text-ivory font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-157" data-mp="nbooh4ij6s3g">
            🎓 Horse Riding Instructor Ready
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-forest" data-id="element-158" data-mp="3j8se7xjcfdo9">
            Solve an entire year of riding lessons{' '}
            <span className="text-pine" data-id="element-159" data-mp="39acyeqprnqu2">in just 5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[280px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-160" data-mp="3e9fs5f0aqamq">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-161" data-mp="35a2fkdgvl5xs" />
          <img src="https://cdn.magicpatterns.com/uploads/8zB5xDGq4zVQgkwECgjUFN/Diseno_sin_titulo_(49).png" alt="Horse Riding Instructor Ready — the complete 6-in-1 teaching system with 6 volumes, 2 manuals and 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-162" data-mp="2ql692kugw0za" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-163" data-mp="s21k8hdb6o2m">
          <p className="text-sm sm:text-lg md:text-xl text-ink leading-snug max-w-2xl mx-auto mb-2 font-medium" data-id="element-164" data-mp="ic88ngd628yd">
            The Complete 6-in-1 Teaching System for Horse Riding Instructors
          </p>
          <p className="text-sm sm:text-base md:text-lg text-warmgray leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-165" data-mp="1b0njrrt6g74f">
            90 Ready-to-Teach Lessons · 6 Progressive Volumes · Everything
            structured from day one to developing rider
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-166" data-mp="110wp9q4m9s4c">
            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-167" data-mp="x1w789tyqtie">
              {CTA_LABEL}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-warmgray" data-id="element-168" data-mp="1xam72v6j3z11">
            {['Complete 6-in-1 System', '5 Strategic Bonuses', 'Immediate Access'].map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-169" data-mp="2b0fy9k5iavdx">
                <CheckCircle size={14} className="text-gold" data-id="element-170" data-mp="2b2sk48edxpw9" />
                <span data-id="element-171" data-mp="2fz0w5cxad2z7">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}